import PedidosRacao from "@/modules/pedidosRacao/pages/PedidosRacao";
import DetalhePedido from "@/modules/pedidosRacao/pages/DetalhePedido";

export default [
	{
		path: '/pedidosRacao',
		name: 'pedidosRacao',
		component: PedidosRacao
	},
	{
		path: '/detalhePedido/:id?',
		name: 'detalhePedido',
		component: DetalhePedido
	},
];
